module.exports = __webpack_public_path__ + "media/9.9b0bfdc6.mp3";